<template>
    <img src="/img/logo_horizontal_2026.png" />
</template>
